//#region ImportsSection
import React, { useState } from "react";
import Draggable from "react-draggable";
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { GetLanguageString } from "../helper/Components";
import ViewPrgressComments from "../member/MemberDetails/ViewPrgressComments";
//#endregion ImportsSection

const ViewMemberComments = ({ task, onClose, refreshBoard }) => {
  //#region StateSection

  const [position, setPosition] = useState({ x: 0, y: 0 });
  //#endregion StateSection
  //#region functionSection
  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  //#endregion functionSection

  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen={true} className="inmodal" autoFocus={false} size="xl">
        <ModalHeader className="modal-title" tag="h4">
          <GetLanguageString props="member_member_detail_course_comment" />
        </ModalHeader>

        <Form>
          <ModalBody>
            <ViewPrgressComments memberId={task.habibId} />
          </ModalBody>
          <ModalFooter>
            <Button color="white" onClick={() => onClose(false)}>
              <GetLanguageString props="common_cancel" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </Draggable>
  );
};

export default ViewMemberComments;
